import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { Table, Button, Form, Pagination } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import { getDownloadDataExcel, postData } from "../../../../utils/api";
import { Link } from "react-router-dom";
import {
  formatDate,
  formatTo12Hour,
  IDS,
  OrderStatusIds,
  ReturnStatusIds,
  RoleId,
  ServiceIds,
} from "../../../../utils/common";
import AssignOffCanvance from "../AssignDeliveryBoy";
import ProductModal from "../ProductModal";
import AssignReturnOffCanvance from "../AssignReturnDeliveryBoy";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
import DatePicker from "react-datepicker";
import search1 from "../../../assets/icons/search.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
function CancelledTable({
  user,
  OrderByOptions,

  storeCategories,

  productCategories,

  vendorServices,
  resultsPerPageOptions,
}) {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
  } = useContext(Context);

  const [perPage, setperPage] = useState({
    value: 25,
    label: "Results per page: 25",
  });

  const [data, setData] = useState([]);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);

  const [reset, setReset] = useState();
  const [searchOrderStatus, setSearchOrderSatatus] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [option, setOption] = useState();
  const [hideFilter, setHideFilter] = useState(false);
  const [storeCategory, setStoreCategory] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [search, setSearch] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");

  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();

  const [searchStartTime, setSearchStartTime] = useState();
  const [searchEndTime, setSearchEndTime] = useState();
  const [sortOrder, setSortOrder] = useState({
    value: "DESC",
    label: "Sort-by date (Descending)",
  });

  const getDataAll = async () => {
    const response = await getData(
      `/admin/orders/reject-order?page=${onPageChange || 1}&per_page=${
        perPage?.value || 25
      }&term=${search}&searchOrderStatus=${
        OrderStatusIds.Rejected || ""
      }&storeCategory=${storeCategory}&productCategory=${
        productCategory?.value || ""
      }&sortOrder=${sortOrder?.value || "DESC"}&from=${
        searchDateFrom || ""
      }&to=${searchDateTo || ""}&start_time=${searchStartTime || ""}&end_time=${
        searchEndTime || ""
      }&name=${search || ""}&customer=${searchCustomer || ""}`
    );
    await setData(response);
    setCurrentPage(response?.data?.current_page);
    // setperPage(response?.data?.per_page);
    settotalPages(response?.data?.total_pages);
    setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    // await GetAllCounts();
  };
  useEffect(() => {
    getDataAll();
  }, [reset, searchOrderStatus, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  const [showAssign, setShowAssign] = useState({ show: 0, data: {} });
  const [showReturnAssign, setShowReturnAssign] = useState({
    show: 0,
    data: {},
  });
  const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "20px",
      borderColor: "#ddd",
      boxShadow: "none",
      fontSize: "15px",
      "&:hover": {
        borderColor: "#aaa",
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#000",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: "#000",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: "#eee",
      },
    }),
  };

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const ChangeOrderStatus = async (id, status_id) => {
    try {
      // Send the POST request to update the store's status
      await postData(`/admin/orders/product-order/update-status/${id}`, {
        order_status_id: status_id,
      });

      // Refresh the data after updating the store's status
      await getDataAll();
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  const downloadInvoice = (invoiceUrl) => {
    // Make a GET request to the backend to trigger the download
    const link = document.createElement("a");
    link.href = invoiceUrl; // The URL of the invoice file on the server
    link.target = "_blank";
    link.download = true; // This ensures the browser triggers a download
    link.click();
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        // await DownloadExcel(
        //   // "/download-excel/download-users",
        //   `/download-excel/download-users?term=${search || ""}&mobile=${mobile || ""}&from=${from || ""}&to=${to || ""}`,
        //   "Users List"
        // );
        await getDownloadDataExcel(
          `/admin/orders/download?page=${onPageChange || 1}&per_page=${
            perPage?.value || 25
          }&term=${search}&searchOrderStatus=${
            OrderStatusIds.Rejected || ""
          }&storeCategory=${storeCategory}&productCategory=${
            productCategory?.value || ""
          }&sortOrder=${sortOrder?.value || "DESC"}&from=${
            searchDateFrom || ""
          }&to=${searchDateTo || ""}&start_time=${
            searchStartTime || ""
          }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
            searchCustomer || ""
          }`,
          null,
          "Subscription Order List"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");
    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);
  return (
    <section className="pending-table_holder">
      {/* Quick Filters Section */}
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row">
            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">Delivery Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  onChange={(e) => {
                    setSearchDateFrom(e.target.value);
                    setonPageChange(1);
                  }}
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">Delivery End Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="to"
                  value={searchDateTo}
                  onChange={(e) => {
                    setSearchDateTo(e.target.value);
                    setonPageChange(1);
                  }}
                />
              </div>
            </div>
            <div className="col-md-3">
              <label className="form-label">Start Time</label>
              <DatePicker
                selected={searchStartTime}
                onChange={(date) => {
                  setSearchStartTime(date);
                  setonPageChange(1);
                }}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Start Time"
                dateFormat="h:mm aa" // 12-hour format
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">End Time</label>
              <DatePicker
                selected={searchEndTime}
                onChange={(date) => {
                  setSearchEndTime(date);
                  setonPageChange(1);
                }}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="End Time"
                dateFormat="h:mm aa"
                className="form-control"
              />
            </div>

            {/* <div className="col-lg-3 mb-2">
              <Form.Label>Select Category </Form.Label>
              <Select
                isSearchable
                options={categories}
                value={searchCategory}
                placeholder="Select Category"
                onChange={(e) => {
                  setSearchCategory(e);
                  getAllSubCategories(e.value);
                  setSearchSubCategory("");
                }}
                classNamePrefix="searchProduct"
              />
            </div>

            <div className="col-lg-3 mb-2">
              <Form.Label>Select Sub Category </Form.Label>
              <Select
                isSearchable
                options={subCategories}
                value={searchSubCategory}
                placeholder="Select Sub Category"
                onChange={(e) => {
                  setSearchSubCategory(e);
                  getAllChildCategories(e.value);
                }}
                classNamePrefix="searchProduct"
              />
            </div>

            <div className="col-lg-3 mb-2">
              <Form.Label>Select Child Category </Form.Label>
              <Select
                isSearchable
                options={childCategories}
                value={searchChildCategory}
                placeholder="Select Child Category"
                onChange={(e) => {
                  setSearchChildCategory(e);
                }}
                classNamePrefix="searchProduct"
              />
            </div> */}
          </div>
        </div>
      </div>
      <div className="row align-items-end mb-3">
        <div className="col-12 mb-2">
          <div className="row">
            <div className="col-lg-3 mb-2">
              <Form.Label>Select Product </Form.Label>
              <Select
                isSearchable
                options={product}
                value={productCategory}
                placeholder="Select Product"
                onChange={(e) => {
                  setProductCategory(e);
                }}
                classNamePrefix="searchProduct"
              />
            </div>
            <div className="col-lg-3 mb-2">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                placeholder="Enter Customer Name"
                type="text"
                className="form-control"
                id=""
                value={searchCustomer}
                onChange={(e) => {
                  setSearchCustomer(e.target.value);
                }}
              />
            </div>
            <div className="col-xxl-1 col-xl-1  col-lg-1 col-md-1">
              <div className="Search me-2">
                <Form.Label>Search</Form.Label>
                <Button
                  type="button"
                  onClick={getDataAll}
                  className="btn btn-search"
                >
                  <img src={search1} className="search" alt="" />
                </Button>
              </div>
            </div>
            <div className="col-xxl-1 col-xl-1  col-lg-2 col-md-2">
              <div className="Search-1">
                <Form.Label>Reset</Form.Label>
                <button
                  type="button"
                  onClick={() => {
                    setSearch("");
                    setSearchDateFrom("");
                    setSearchDateTo("");
                    setSearchEndTime("");
                    setSearchStartTime("");
                    setSearchCustomer("");
                    setProductCategory("");
                    setReset(!reset);
                  }}
                  className="btn btn-reset"
                >
                  Reset
                </button>
              </div>
            </div>

            <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              <Form.Label> Download Excel</Form.Label>
              <div>
                <button
                  className="btn btn-success mt-2"
                  type="button"
                  onClick={HandleDownload}
                >
                  Excel
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="filters-section">
        <div className="filters-section__label">
          <Button
            className="hide_btn mb-3"
            onClick={() => {
              setHideFilter(!hideFilter);
              setStoreCategory("");
              setSortOrder({
                value: "DESC",
                label: "Sort-by date (Descending)",
              });
              setperPage({ value: 25, label: "Results per page: 25" });
              setReset();
            }}
          >
            {" "}
            {!hideFilter ? "Hide Filter" : "Show Filter"}
          </Button>
          <h6>
            <span>{data?.data?.total} Orders</span>
          
          </h6>
        </div>
        {!hideFilter && (
          <div className="filters-section__controls">
            <div className="row">
              <div className="col-lg-3 mb-2">
                <Select
                  options={OrderByOptions}
                  // defaultValue={OrderByOptions[0]}
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e)}
                  className="filters-section__dropdown"
                  classNamePrefix="react-select"
                  styles={customSelectStyles}
                />
              </div>
              <div className="col-lg-3 mb-2">
                <Select
                  options={resultsPerPageOptions}
                  // defaultValue={resultsPerPageOptions[0]}
                  value={perPage}
                  onChange={(e) => setperPage(e)}
                  className="filters-section__dropdown"
                  classNamePrefix="react-select"
                  styles={customSelectStyles}
                />
              </div>
              <div className="col-lg-3 mb-2">
                <Button
                  variant="outline-secondary"
                  className="filters-section__btn active me-1"
                  onClick={() => {
                    setonPageChange(1);
                    getDataAll();
                  }}
                >
                  Set Table Preferences
                </Button>
                <Button
                  variant="outline-secondary"
                  className="filters-section__btn"
                  onClick={() => {
                    setStoreCategory("");
                    setSortOrder({
                      value: "DESC",
                      label: "Sort-by date (Descending)",
                    });
                    setperPage({ value: 25, label: "Results per page: 25" });
                    setonPageChange(1);
                    setReset(!reset);
                  }}
                >
                  Refresh
                </Button>
              </div>
            </div>

            
          </div>
        )}
      </div> */}

      {/* Table Section */}
      <div className="pending-table ">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              <th>Order Date</th>
              <th>Order details</th>

              <th>Products</th>
              <th>Total</th>
              <th>Delivery Details</th>
              <th>Order Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.data?.map((item, index) => (
              <tr key={index}>
                <td className="order-date">
                  <div className="order-id">
                    {calculateTimeAgo(item?.createdAt)}
                  </div>
                  <div className="order-info">
                    <span>
                      {new Date(item?.createdAt).toISOString().split("T")[0]}
                    </span>
                  </div>
                  <div className="order-info">
                    <span>{formatTimeInIST(item?.createdAt)} IST</span>
                  </div>
                </td>

                {/* Owner Details */}
                <td className="order-details">
                  <div className="order-id text-highlight">
                    {item?.invoice_no}
                  </div>
                  <div className="order-info">
                    <span>Buyer Name</span>
                  </div>
                  <div className="order-info">
                    <span className="text-highlight">{item?.User?.name}</span>
                  </div>
                  <div className="order-info">
                    <span className="order-info">{item?.User?.contact_no}</span>
                  </div>

                  <div className="order-info">
                    <span>Payment Method</span> :{" "}
                    <span>{item?.Payment_Method?.name}</span>
                  </div>

                  {/* <div className="order-info">
                    <span>{item?.user?.type}</span>
                  </div> */}
                </td>

                <td className="order-details">
                  {item?.Product_Order_Details?.map((product) => (
                    <>
                      <div className="text-highlight">
                        <span>{product?.Product?.name}</span>
                      </div>
                      <div className="order-info">
                        <span>{product?.Product?.p_category?.name} </span>
                      </div>
                    </>
                  ))}
                  <div></div>
                  <div className=" mt-3">
                    <Button
                      className="action-btn active"
                      onClick={() =>
                        setShowDetails({
                          show: item?.id,
                          data: item?.Product_Order_Details,
                        })
                      }
                    >
                      View All Details
                    </Button>
                  </div>
                </td>

                <td className="order-details">
                  {(() => {
                    const details = item?.Product_Order_Details || [];

                    // Reduce to calculate totals
                    const totals = details.reduce(
                      (acc, curr) => {
                        acc.total_selling_price += Number(
                          curr.total_selling_price || 0
                        );
                        acc.packing_charges += Number(
                          curr.packing_charges || 0
                        );
                        acc.delivery_charges += Number(
                          curr.delivery_charges || 0
                        );
                        acc.offer_discount += Number(curr.offer_discount || 0);
                        acc.coupon_discount += Number(
                          curr.coupon_discount || 0
                        );
                        acc.total_tax += Number(curr.total_tax || 0);
                        acc.total_amount += Number(curr.total_amount || 0);
                        return acc;
                      },
                      {
                        total_selling_price: 0,
                        packing_charges: 0,
                        delivery_charges: 0,
                        offer_discount: 0,
                        coupon_discount: 0,
                        total_tax: 0,
                        total_amount: 0,
                      }
                    );

                    return (
                      <>
                        <div className="order-id">
                          <span>Total SubTotal</span>
                        </div>
                        <div className="order-info">
                          <span>{totals.total_selling_price} /-</span>
                        </div>

                        <div className="order-id">
                          <span>Packing Charges</span>
                        </div>
                        <div className="order-info">
                          <span>{totals.packing_charges} /-</span>
                        </div>

                        <div className="order-id">
                          <span>Delivery Charges</span>
                        </div>
                        <div className="order-info">
                          <span>{totals.delivery_charges} /-</span>
                        </div>

                        <div className="order-id">
                          <span>Offer Discount</span>
                        </div>
                        <div className="order-info">
                          <span>{totals.total_offer_discount} /-</span>
                        </div>

                        <div className="order-id">
                          <span>Coupon Discount</span>
                        </div>
                        <div className="order-info">
                          <span>{totals.total_coupon_discount} /-</span>
                        </div>

                        <div className="order-id">
                          <span>Total Tax</span>
                        </div>
                        <div className="order-info">
                          <span>{totals.total_tax} /-</span>
                        </div>

                        <div className="order-id">
                          <span>Grand Total</span>
                        </div>
                        <div className="text-highlight">
                          <span>{totals.total_amount} /-</span>
                        </div>
                      </>
                    );
                  })()}
                </td>

                <td>
                  <>
                    <div className="text-highlight">
                      <span>
                        {item?.User_Address?.first_name}{" "}
                        {item?.User_Address?.last_name}
                      </span>
                    </div>
                    <div className="order-info">
                      <span>{item?.User_Address?.floor} floor ,</span>
                      <span>{item?.User_Address?.building}, </span>
                      <span>{item?.User_Address?.apartment} ,</span>
                      <span>{item?.User_Address?.street}, </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {
                          item?.User_Address?.Users_Address_Detail?.Country
                            ?.name
                        }{" "}
                        ,
                      </span>
                      <span>
                        {item?.User_Address?.Users_Address_Detail?.State?.name},{" "}
                      </span>
                      <span>
                        {item?.User_Address?.Users_Address_Detail?.City?.name} ,
                      </span>
                      <span>
                        {item?.User_Address?.Users_Address_Detail?.Area?.name},{" "}
                      </span>
                      <span>
                        {
                          item?.User_Address?.Users_Address_Detail?.Pincode
                            ?.name
                        }
                        ,{" "}
                      </span>
                    </div>
                    <div className="order-info">
                      <span>{item?.User_Address?.address_type}</span>
                    </div>
                    <div className="text-highlight">
                      <span>{item?.User_Address?.contact_no} </span>
                    </div>

                    <div className="order-id">
                      <span>Delivery Date</span>
                    </div>
                    <div className="text-highlight">
                      <span>{formatDate(item?.delivery_date)} </span>
                    </div>
                    <div className="order-id">
                      <span>Time Slot</span>
                    </div>
                    <div className="text-highlight">
                      <span>
                        {formatTo12Hour(item?.Time_Slot?.from)}-
                        {formatTo12Hour(item?.Time_Slot?.to)}{" "}
                      </span>
                    </div>
                  </>
                  {/* ) : item?.service_id == ServiceIds.DineIn ? (
                        <>
                          <div className="order-info">
                            {" "}
                            <span> Table No :-</span>{" "}
                          </div>
                          <div className="text-highlight">
                            <span>{item?.table_no}</span>
                          </div>
                        </>
                      ) : item?.service_id == ServiceIds.RoomService ? (
                        <>
                          <div className="order-info">
                            {" "}
                            <span> Room No :-</span>{" "}
                          </div>
                          <div className="text-highlight">
                            <span>{item?.room_no}</span>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}{" "}
                    </>
                  ) : (
                    <>
                      <div className="text-highlight">
                        <span>
                          {item?.User_Address?.first_name}{" "}
                          {item?.User_Address?.last_name}
                        </span>
                      </div>
                      <div className="order-info">
                        <span>{item?.User_Address?.floor} floor ,</span>
                        <span>{item?.User_Address?.building}, </span>
                        <span>{item?.User_Address?.apartment} ,</span>
                        <span>{item?.User_Address?.street}, </span>
                      </div>
                      <div className="order-info">
                        <span>{item?.User_Address?.address_type}</span>
                      </div>
                      <div className="text-highlight">
                        <span>{item?.User_Address?.contact_no} </span>
                      </div>
                    </>
                  )} */}
                </td>

                <td>
                  <div>
                    <p className="status-holder shipped">Rejected</p>
                  </div>
                   <div>
                    <p className="status-holder shipped">  Rejected  Message : <span>{item?.Order_Rejection?.message || "NA"}</span> </p>
                  </div>
                   <div>
                    <p className="status-holder shipped">  Rejected  Reason : <span>{item?.Order_Rejection?.Reject_Reason?.name}</span> </p>
                  </div>

                  {item?.Order_History?.delivery_boy_assigned && (
                    <div className="order-info">
                      Delivery Boy Asigned At
                      <div className="order-info">
                        <span>
                          {
                            new Date(item?.Order_History?.delivery_boy_assigned)
                              .toISOString()
                              .split("T")[0]
                          }
                          {formatTimeInIST(
                            item?.Order_History?.delivery_boy_assigned
                          )}{" "}
                          IST
                        </span>
                      </div>
                    </div>
                  )}

                  {item?.Order_History?.out_for_delivery && (
                    <div className="order-info">
                      Out For Delivery At
                      <div className="order-info">
                        <span>
                          {
                            new Date(item?.Order_History?.out_for_delivery)
                              .toISOString()
                              .split("T")[0]
                          }
                          {formatTimeInIST(
                            item?.Order_History?.out_for_delivery
                          )}{" "}
                          IST
                        </span>
                      </div>
                    </div>
                  )}

                  {item?.Order_History?.cancelledAt && (
                    <div className="order-info">
                      Cancelled At
                      <div className="order-info">
                        <span>
                          {
                            new Date(item?.Order_History?.cancelledAt)
                              .toISOString()
                              .split("T")[0]
                          }
                          {formatTimeInIST(item?.Order_History?.cancelledAt)}{" "}
                          IST
                        </span>
                      </div>
                    </div>
                  )}

                  {item?.Order_History?.returnRequestedAt && (
                    <div className="order-info">
                      Return Requested At
                      <div className="order-info">
                        <span>
                          {
                            new Date(item?.Order_History?.returnRequestedAt)
                              .toISOString()
                              .split("T")[0]
                          }
                          {formatTimeInIST(
                            item?.Order_History?.returnRequestedAt
                          )}{" "}
                          IST
                        </span>
                      </div>
                    </div>
                  )}

                  {item?.Order_History?.returnScheduledAt && (
                    <div className="order-info">
                      Return Scheduled At
                      <div className="order-info">
                        <span>
                          {
                            new Date(item?.Order_History?.returnScheduledAt)
                              .toISOString()
                              .split("T")[0]
                          }
                          {formatTimeInIST(
                            item?.Order_History?.returnScheduledAt
                          )}{" "}
                          IST
                        </span>
                      </div>
                    </div>
                  )}

                  {item?.Order_History?.itemPickedAt && (
                    <div className="order-info">
                      Item Picked At
                      <div className="order-info">
                        <span>
                          {
                            new Date(item?.Order_History?.itemPickedAt)
                              .toISOString()
                              .split("T")[0]
                          }
                          {formatTimeInIST(item?.Order_History?.itemPickedAt)}{" "}
                          IST
                        </span>
                      </div>
                    </div>
                  )}

                  {item?.Order_History?.returnedAt && (
                    <div className="order-info">
                      Returned At
                      <div className="order-info">
                        <span>
                          {
                            new Date(item?.Order_History?.returnedAt)
                              .toISOString()
                              .split("T")[0]
                          }
                          {formatTimeInIST(item?.Order_History?.returnedAt)} IST
                        </span>
                      </div>
                    </div>
                  )}

                  {item?.Order_History?.refundedAt && (
                    <div className="order-info">
                      Refunded At
                      <div className="order-info">
                        <span>
                          {
                            new Date(item?.Order_History?.refundedAt)
                              .toISOString()
                              .split("T")[0]
                          }
                          {formatTimeInIST(item?.Order_History?.refundedAt)} IST
                        </span>
                      </div>
                    </div>
                  )}
                </td>
                <td>
                  {!item?.Return_Order ? (
                    <>
                      {item?.delivery_boy ? (
                        <>
                          <div className="my-1">
                            <Button className="action-btn active">
                              {" "}
                              {item?.delivery_boy?.name}
                            </Button>
                          </div>
                        </>
                      ) : item?.Store_Detail?.s_category?.is_restaurant_flow ? (
                        <>
                          {" "}
                          {item?.order_status_id ===
                            OrderStatusIds.Processing &&
                            user?.role_id === RoleId.Vendor && (
                              <>
                                {item?.service_id == ServiceIds.Delivery ||
                                item?.service_id == ServiceIds.RoomService ? (
                                  <div className="my-1">
                                    <Button
                                      className="action-btn active"
                                      onClick={() =>
                                        setShowAssign({
                                          show: item?.id,
                                          data: item?.User_Address,
                                        })
                                      }
                                    >
                                      {" "}
                                      Assign Delivery Boy{" "}
                                    </Button>
                                  </div>
                                ) : (
                                  <div className="my-1">
                                    <Button
                                      className="action-btn active"
                                      onClick={() =>
                                        ChangeOrderStatus(
                                          item?.id,
                                          OrderStatusIds.PickupSchedued
                                        )
                                      }
                                    >
                                      {" "}
                                      Cooked{" "}
                                    </Button>
                                  </div>
                                )}
                              </>
                            )}
                        </>
                      ) : (
                        <>
                          {item?.order_status_id ===
                            OrderStatusIds.Processing &&
                            user?.role_id === RoleId.Vendor && (
                              <div className="my-1">
                                <Button
                                  className="action-btn active"
                                  onClick={() =>
                                    setShowAssign({
                                      show: item?.id,
                                      data: item?.User_Address,
                                    })
                                  }
                                >
                                  {" "}
                                  Assign Delivery Boy{" "}
                                </Button>
                              </div>
                            )}

                          {item?.Return_Order?.return_reason_id ===
                            ReturnStatusIds.ReturnRequested &&
                            user?.role_id === RoleId.Vendor && (
                              <div className="my-1">
                                <Button
                                  className="action-btn active"
                                  onClick={() =>
                                    setShowReturnAssign({
                                      show: item?.id,
                                      data: item?.User_Address,
                                    })
                                  }
                                >
                                  {" "}
                                  Assign Delivery Boy{" "}
                                </Button>
                              </div>
                            )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {item?.Return_Order?.User ? (
                        <>
                          <div className="my-1">
                            <Button className="action-btn active">
                              {" "}
                              {item?.Return_Order?.User?.name}
                            </Button>
                          </div>
                        </>
                      ) : item?.Store_Detail?.s_category?.is_restaurant_flow ? (
                        <>
                          {" "}
                          {item?.Return_Order?.return_status_id ===
                            ReturnStatusIds.ReturnRequested &&
                            user?.role_id === RoleId.Vendor && (
                              <>
                                {item?.service_id == ServiceIds.Delivery ||
                                item?.service_id == ServiceIds.RoomService ? (
                                  <div className="my-1">
                                    <Button
                                      className="action-btn active"
                                      onClick={() =>
                                        setShowAssign({
                                          show: item?.id,
                                          data: item?.User_Address,
                                        })
                                      }
                                    >
                                      {" "}
                                      Assign Delivery Boy{" "}
                                    </Button>
                                  </div>
                                ) : (
                                  <div className="my-1">
                                    {/* <Button
                                      className="action-btn active"
                                      onClick={() =>
                                        ChangeOrderStatus(
                                          item?.id,
                                          OrderStatusIds.PickupSchedued
                                        )
                                      }
                                    >
                                      {" "}
                                      Cooked{" "}
                                    </Button> */}
                                  </div>
                                )}
                              </>
                            )}
                        </>
                      ) : (
                        <>
                          {item?.Return_Order?.return_status_id ===
                            ReturnStatusIds.ReturnRequested &&
                            user?.role_id === RoleId.Vendor && (
                              <div className="my-1">
                                <Button
                                  className="action-btn active"
                                  onClick={() =>
                                    setShowReturnAssign({
                                      show: item?.id,
                                      data: item?.User_Address,
                                    })
                                  }
                                >
                                  {" "}
                                  Assign Delivery Boy{" "}
                                </Button>
                              </div>
                            )}
                        </>
                      )}
                    </>
                  )}

                  {item?.order_status_id === OrderStatusIds.Pending && (
                    <>
                      <div className="my-1">
                        <Button
                          className="action-btn active"
                          onClick={() =>
                            ChangeOrderStatus(
                              item?.id,
                              OrderStatusIds.Processing
                            )
                          }
                        >
                          {" "}
                          Accept Order{" "}
                        </Button>
                      </div>

                      <div className="my-1">
                        <Button
                          className="action-btn"
                          onClick={() =>
                            ChangeOrderStatus(
                              item?.id,
                              OrderStatusIds.Cancelled
                            )
                          }
                        >
                          {" "}
                          Reject Order{" "}
                        </Button>
                      </div>
                    </>
                  )}

                  {/* <div className="my-1">
                    <Button
                      className="action-btn"
                      onClick={() => downloadInvoice(IMG_URL + item?.invoice)}
                    >
                      Print Tax Invoice
                    </Button>
                  </div> */}

                  {/* {item?.order_status_id !== OrderStatusIds.Cancelled && (
                    <div className="my-1">
                      <Button
                        className="action-btn"
                        onClick={() =>
                          ChangeOrderStatus(item?.id, OrderStatusIds.Cancelled)
                        }
                      >
                        Cancel Order
                      </Button>
                    </div>
                  )} */}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {data && data?.data?.data?.length > 0 ? (
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        ) : (
          <p className="no-datashow">Sorry, No Data Found</p>
        )}
      </div>
      <AssignOffCanvance
        handleClose={() => {
          setShowAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowAssign({ show: 0, data: {} })}
        show={showAssign?.show}
        data={showAssign?.data}
      />
      <AssignReturnOffCanvance
        handleClose={() => {
          setShowReturnAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowReturnAssign({ show: 0, data: {} })}
        show={showReturnAssign?.show}
        data={showReturnAssign?.data}
      />
      <ProductModal
        handleClose={() => {
          setShowDetails({ show: 0, data: {} });
        }}
        setShow={() => setShowDetails({ show: 0, data: {} })}
        show={showDetails?.show}
        data={showDetails?.data}
      />
    </section>
  );
}

export default CancelledTable;
